import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import {ChevronDown} from 'lucide-react'

const FAQS = [
  {
    q: 'What is less than truckload (LTL) shipping?',
    a: 'Less than truckload (LTL) shipping is a freight mode where multiple shippers share space on the same trailer. Instead of paying for an entire truck, you only pay for the portion your freight occupies, determined by weight, freight class, dimensions, and lane. LTL is the ideal choice for palletized B2B shipments that are too large for parcel but do not fill a full 53ft trailer.',
  },
  {
    q: 'How is a trucking price per mile calculated?',
    a: 'A trucking price per mile is calculated by multiplying the total lane distance by a per-mile line-haul rate. Our full truckload model uses roughly $2.50 per mile as a baseline, then layers in fuel surcharges, accessorials, and cargo-specific fees such as hazmat. Actual per-mile rates fluctuate with fuel prices, equipment type, seasonality, and lane balance.',
  },
  {
    q: 'How can I get an accurate FedEx freight rate quote?',
    a: 'To get an accurate FedEx Freight rate quote, you need precise origin and destination zip codes, total weight, dimensions, freight class, and any accessorials such as liftgate or residential delivery. The Freight Calculator gives you an instant baseline estimate, then connects you with vetted B2B carrier networks, including national LTL providers, to lock in firm, comparable rates.',
  },
]

function Faq() {
  const [open, setOpen] = useState<number | null>(0)

  return (
    <section id="faq" className="bg-white py-20 lg:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="text-xs font-bold uppercase tracking-wider text-[#10B981]">
            Freight FAQ
          </span>
          <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold text-[#0F172A] tracking-tight">
            Common freight questions
          </h2>
          <p className="mt-3 text-slate-600">
            Everything you need to know about pricing, modes, and getting firm carrier rates.
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {FAQS.map((item, i) => {
            const isOpen = open === i
            return (
              <div
                key={item.q}
                className="rounded-xl border border-slate-200 bg-[#F1F5F9]/60 overflow-hidden"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-[#0F172A]">{item.q}</span>
                  <ChevronDown
                    className={`w-5 h-5 text-[#10B981] shrink-0 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen ? (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                    >
                      <p className="px-5 pb-5 text-sm text-slate-600 leading-relaxed">{item.a}</p>
                    </motion.div>
                  ) : null}
                </AnimatePresence>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Faq
